import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncAddTier = ({ commit, dispatch, state, rootState }, payload) => {
	
	var objAuth = JSON.parse(rootState.objAuthorize);
	var tierDetails = { manufacturer: objAuth.manufacturer, user: objAuth.id, minBlinds: payload.minBlinds, maxBlinds: payload.maxBlinds, total: payload.total };	
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=create_installation_tier', tierDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The tier could not be added', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The tier was added successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch('fncPopulateTiers');
		});
}

export const fncPopulateTiers = ({ commit, dispatch, state, rootState }, payload) => {		
		var objAuth = JSON.parse(rootState.objAuthorize);
		var tierDetails = { manufacturer: objAuth.manufacturer };
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=retrieve_installation_tiers', tierDetails, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {

				Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=retrieve_installation_tier_base', tierDetails, rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						console.log(error);
					}).then(d => {
						
						var minItem = 1;
						for (var i in data) {
							minItem = parseInt(data[i].maximum) + 1;
						}

						var addBase = { id: 0, minimum: minItem, maximum: '-', total: d[0].install_increment + ' per item' }
						data.push(addBase);

						commit('fncSetTiers', data);				
					});
                
			});
		
};

export const fncTierDelete = ({ commit, dispatch, state, rootState }, payload) => {	
	var tierDetails = { id: payload.tierId };	
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=delete_tier', tierDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The tier was removed successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			commit('fncEmptyTiers');
			dispatch('fncPopulateTiers');
		});
};

export const fncEditTier = ({ commit, dispatch, state, rootState }, payload) => {
    
	var tierDetails = { id: payload.id, minBlinds: payload.minimum, maxBlinds: payload.maximum, total: payload.total };
    
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=update_installation_tier', tierDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The tier could not be updated', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The tier was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch('fncPopulateTiers');
		});
};

export const fncGetBasePriceModal = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var tierDetails = { manufacturer: objAuth.manufacturer };	
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=retrieve_installation_tier_base', tierDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var modalDetails = { title: 'Update Base Installation Cost', component: 'modal-base-price', mstate: true, params: { base: data[0].install_increment } };
			commit({
				type: 'setModal',
				details: modalDetails
			});            
		});
};

export const fncGetBasePrice = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var tierDetails = { manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=retrieve_installation_tier_base', tierDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {			
			commit('fncSetBasePrice', data[0].install_increment);
		});
};

export const fncUpdateBaseTier = ({ commit, dispatch, state, rootState }, payload) => {	
	var objAuth = JSON.parse(rootState.objAuthorize);
	var tierDetails = { manufacturer: objAuth.manufacturer, base: payload };	
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=update_tier_base_price', tierDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {			
			commit('fncSetBasePrice', payload);
			var snackDetails = { color: 'success', message: 'The base price was updated successfully', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');			            
			dispatch('fncPopulateTiers');
		});
};